export const AUDIT_LINK = "https://wokprofit-calculator-git-dev-codingkaos-projects.vercel.app/";
export const REVENUE_ENGINE_PATH = "/revenue-engine";
